window.getQS = function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function getTlds() {
    if (getQS('tlds') !== '')  {
        return getQS('tlds').split(',');
    }

    if (getQS('tld') !== '') {
        return [getQS('tld').split(',')[0]];
    }

    return 'any';
}

App.controller('AccountCtrl', function($scope, $location, $rootScope, $routeParams, domainHelper) {
	// check if formData is not set
	if (!$rootScope.selectedDomain) {
		$location.path('/');
	}
	
	// focus on first input
	setTimeout(function() {
		$('#formAccount').find(':input').eq(0).focus();
	}, 50);

	$scope.$watch('formAccount.$valid', function() {
		$rootScope.accountValidation = $scope.formAccount.$valid;
	});
	
});

App.controller('EmptyCtrl', function($scope, $rootScope, $location, $route, $timeout){
	void 0;

	$rootScope.suggestions = [];
	$rootScope.selectedStarterPage = null;
	$rootScope.showAlerts = false;

	$rootScope.showTitle = '';
	$rootScope.showSubtitle = '';

	$rootScope.domainError = false;
	$rootScope.available = false;

	$scope.transferError = false;
	$scope.transferMsg = '';
	$scope.transferResp = '';

	if ($rootScope.toggleSignup) {
		$rootScope.toggleSignup('hide');
	}
	
	// should we open the pricing modal immediately
	if (!$rootScope.firstTime && location.href.indexOf('store') != -1) {
		$rootScope.firstTime = true;
		if (getQS('o') == '1') {
			$timeout(function(){
				$location.path('/modal');
				$location.replace();
				$rootScope.showregmodal = true;
			}, 0);
		}
	}

	$rootScope.getPlan = function(plan) {
		void 0;

		$rootScope.showregmodal = true;
		$rootScope.selectedPlanModal = plan;
		$rootScope.service = POP.currentService.data.service;
		$rootScope.selectedPlan = POP.currentServicePlans.json.plans[plan];

        if (typeof _kmq != 'undefined') {
            _kmq.push([
            	'record',
            	'Service-' + $rootScope.service.slug + '-SelectedPlan-' + (POP.currentServicePlans.json.current_plan === null ? 'new' : POP.currentServicePlans.json.current_plan.slug) + '-' + plan]
            );
        }

		// but heavens, please show viewcontainer
		$rootScope.toggleSignup('show');

		// wait let's check if user is logged in
		if (typeof POP.currentUser == 'object') {
			$location.url('/modal/existing/domains');
		} else {
			// go to domain view
			$location.path('/register');
			$location.replace();
		}
	}
});

App.controller('DomainCtrl', function($scope, $route, $rootScope, domainService, $location){
	var timeout, 
		$mainError = $('#main-error');

	// for directive lookups
	this.id = 'domainCtrl';

	$rootScope.suggestions = [];
	$rootScope.selectedStarterPage = null;
	$rootScope.showAlerts = false;

	$rootScope.showTitle = '';
	$rootScope.showSubtitle = '';

	$rootScope.domainError = false;
	$rootScope.available = false;

	// initially flag as not a transfer
	$rootScope.is_transfer = false;

	$scope.transferError = false;
    $scope.transferMsg = '';
    $scope.transferResp = '';

    /**
     * Initialize our search.
     */
    $scope.init = function() {
        var queryDomain = getQS('d'),
            showRegister = queryDomain != null && queryDomain.length > 0;

        // focus on first input
        setTimeout(function() {
            $('#formDomain').find(':input').eq(0).focus();
        }, 50);

        if (queryDomain) {
            $scope.checkDomain();
        }
    };

    $scope.$on('$routeChangeSuccess', function () {
        var $dlpTabs = $('.dlp-tabs');

        $dlpTabs.find('a[data-toggle="tab"]').on('show.bs.tab', function(ev) {
             var $t = $(ev.target);

            // don't switch tabs if already searching... let it finish first
            if ($rootScope.ajax) {
                return false;
            }

            // stop search just in case they switched tabs before $rootScope.ajax has been set to true
            setTimeout(function () {
                domainService.stop();
            }, 610);

            if ($t.hasClass('owndomain')) {
                // hide steps breadcrumb
                $('.chevron-breadcrumb').hide();

                // hide suggestions and reset search input
                $('input.domain-form').val('');

                // reset some fields
                $rootScope.showSubtitle = '';
                $rootScope.showTitle = '';
                $rootScope.suggestions = [];
                $rootScope.available = false;
                $rootScope.$apply();
            }

            if($t.hasClass('newdomain')) {
                $('.chevron-breadcrumb').show();
            }
        });
    });

	$scope.switchLogin = function() {
		$location.url('/modal/login');
	};

    /**
     * Check if a given domain is transferrable.
     */
    $scope.checkDomainTransfer = function() {
    	// first check domain
    	domainService.isDomainTransferValid($rootScope.formData).then(function(resp) {
    		void 0;

    		// wtf is this for
    		$scope.transferRequestResp = resp;

    		if (resp.code == 200) {
    			domainService.isDomainTransferTokenValid($rootScope.formData).then(function(resp2) {
    				if (resp2.code == 200) {
    					// flag as transfer
    					$rootScope.is_transfer = true;

    					// todo: initiate transfer form by selecting the domain
    					$rootScope.selectDomain(resp2.data.domain);
    				} else {
		                // handle error(s)
		                if (resp.errors) {
		                    var errors = [];
		                    for (var key in resp.errors) {
		                        for (var key2 in resp.errors[key]) {
		                            errors.push(resp.errors[key][key2]);
		                        }
		                    }
		                }

		                $scope.transferError = errors;
		                $scope.transferMsg = resp.msg;
    				}
    			});
    		} else {
    			// handle error(s)
                if (resp.errors) {
                    var errors = [];
                    for (var key in resp.errors) {
                        for (var key2 in resp.errors[key]) {
                            errors.push(resp.errors[key][key2]);
                        }
                    }
                }

                $scope.transferError = errors;
                $scope.transferMsg = resp.msg;
    		}
    	});
    }

    /**
     * Handle checking for a delay.
     */
	$scope.checkDomain = function(delay) {
		delay = (delay === true) ? 600 : 0;

		// flag as not a transfer
		$rootScope.is_transfer = false;

		$rootScope.showTitle = '';
		$rootScope.showSubtitle = '';

		$rootScope.selectedDomain = null;
		$rootScope.selectedStarterPage = null;
		$rootScope.showAlerts = false;
		$rootScope.showResendMessage = false;
		$rootScope.available = false;
		$rootScope.domainError = false;

		// stop prior
		domainService.stop();

		if (timeout) {
			clearTimeout(timeout);
		}
			
		// only search if the value is greater than 2
		if ($rootScope.formData.domain.length >= 2) {
			timeout = setTimeout(function() {
				void 0;

				if ($rootScope.formDomain.$valid === true) {
					checkAvailable($rootScope.formData.domain);
				} else {
                    var domains = '.' + $rootScope.anytld.join(', .').toUpperCase();
                    var st = "Try a " + domains;
                    st = st.replace(/,(?![\s\S]*,)/g, ' or ');

                    $rootScope.domainError = true;
                    $rootScope.showTitle = "Whoops...";
                    $rootScope.showSubtitle = st;
                    $rootScope.$apply();
                }
			}, delay);
		}
	}

	/**
	 * Handle selecting a domain.
	 */
	$rootScope.selectDomain = function(domainObj) {
		// tag inspectlet
		if (typeof __insp != 'undefined') {
			__insp.push(['tagSession', { domain:domainObj.Domain }]);
		}

		//set global selectedDomain
		$rootScope.selectedDomain = domainObj;

		// update the TLD if applicable
		if (typeof domainObj.TLD === 'undefined') {
			$rootScope.selectedDomain.TLD = domainObj.Domain.split('.')[1];
		}

		void 0;
		
		// hide suggestions 
		$rootScope.suggestions = [];

		// hide available
		$rootScope.available = false;

		// before we go to next step, verify domain is valid
		// checkAvailable($rootScope.selectedDomain.Domain,true,false);
		$rootScope.nextStep();
	}

	/**
	 * Decide where to focus.
	 */
	$rootScope.setFormOffset = function() {
		// set variables
		$rootScope.domainSuggestionsVisible = $(".domain-suggestion-wrapper").is(":visible");
		if (!$rootScope.domainSuggestionsVisible) {
			POP.scrollTo("#domain", true, true);
		} else {
			POP.scrollTo("#closeSignup", true, false, 0);
		}
	}

	/**
	 * Get a formatted WHOIS address.
	 */
	$rootScope.getWhoisAddress = function() {
		var address = $rootScope.formData.whois_name + '<br>';
		if ($rootScope.formData.whois_organization.length) {
			address += $rootScope.formData.whois_organization + '<br>';
		}
		address += $rootScope.formData.whois_address_line1 + '<br>';
		if ($rootScope.formData.whois_address_line2.length) {
			address += $rootScope.formData.whois_address_line2 + '<br>';
		}
		address += $rootScope.formData.whois_city + ', ';
		address += $rootScope.formData.whois_state + ' ';
		address += $rootScope.formData.whois_zip + ' ';
		address += $rootScope.formData.whois_country;

		return address;
	}

	/**
	 * Populate our billing page with WHOIS information.
	 */
	$rootScope.populateBillingWithWhoisAddress = function($event) {
		var checkbox = $event.target;

		if (checkbox.checked) {
			$rootScope.formData.comm_email = $rootScope.formData.whois_email;
			$rootScope.formData.cc_name = $rootScope.formData.whois_name;
			$rootScope.formData.company = $rootScope.formData.whois_organization;
			$rootScope.formData.address_line1 = $rootScope.formData.whois_address_line1;
			$rootScope.formData.address_line2 = $rootScope.formData.whois_address_line2;
			$rootScope.formData.address_city = $rootScope.formData.whois_city;
			$rootScope.formData.address_state = $rootScope.formData.whois_state;
			$rootScope.formData.address_zip = $rootScope.formData.whois_zip;
			$rootScope.formData.address_country = $rootScope.formData.whois_country;

			// focus on the first field we need them to fill out
			$('#formPayment').find('#cc_num').focus();
		}
	}

	/**
	 * Check domain availability.
	 */
	function checkAvailable(domain, next, showsuggestions) {
		domainService.checkTld(domain).then(function(resp) {
			void 0;
			
			//check if it is a response and not empty string from a cancel
			if (typeof resp == 'object') {
				$rootScope.domainError = false;
				$rootScope.available = false;

				if (resp.code === 200) {
					// if an exact match domain is available
					if (resp.available === true) {
						// message depends if it was an exact match or a .CO special match
						if (resp.is_keyword === false) {
							$rootScope.showTitle = 'The domain you searched for is available.';
						} else {
							$rootScope.showTitle = 'The .CO version of your domain is available!';
						}

						if (resp.similar_domains.length) {
							$rootScope.showSubtitle = 'Pick from one of the available domains below or try searching again.'
						} else {
							$rootScope.showSubtitle = '';
						}

						$rootScope.available = true;
					} else {
						if (resp.is_keyword === false) {
							if (resp.similar_domains.length) {
								$rootScope.showTitle = 'The domain you searched for is not available. Try these suggestions.';
							} else {
								$rootScope.domainError = true;
								$rootScope.showTitle = 'The domain you searched for is not available.';
								if (resp.similar_domains.length > 0) {
									$rootScope.showSubtitle = 'Choose from our suggested domains below or try searching again.';
								} else {
									$rootScope.showSubtitle = 'Try searching for another domain or keywords.';
								}
							}
						} else if (resp.similar_domains.length) {
							$rootScope.showSubtitle = 'Choose from our suggested domains below or try searching again.';
						} else {
							$rootScope.showTitle = 'We have no suggestions for your keywords. Try searching again. ';
							$rootScope.domainError = true;
						}

						$rootScope.available = false;
					}

					if (next === true) {
						$rootScope.nextStep();
					}
				} else {
					// check for blacklisted
					if (resp.blacklisted === true) {
						$rootScope.domainError = true;
						$rootScope.showTitle = 'The domain you entered appears to contain blacklisted keywords.';
						if (resp.similar_domains.length > 0) {
							$rootScope.showSubtitle = 'Choose from our suggested domains below.';
						} else {
							$rootScope.showSubtitle = 'Try searching for another domain or keywords.';
						}
					} else if (resp.available === false) {
						// if this was an exact domain search
						if (resp.is_keyword === false) {
							$rootScope.showTitle = 'The domain you searched for is not available.';
							$rootScope.domainError = true;
							if (resp.similar_domains.length > 0) {
								$rootScope.showSubtitle = 'Choose from our suggested domains below.';
							} else {
								$rootScope.showSubtitle = 'Try searching for another domain or entering keywords instead.';
							}
						// if we have domain suggestions
						} else if (resp.similar_domains.length > 0) {
							$rootScope.showTitle = 'We have some suggestions for you.';
							$rootScope.showSubtitle = 'Choose from our suggested domains below.';
						// todo: handle some error scenarios
						} else {
							$rootScope.domainError = true;
							$rootScope.showSubtitle = '';

							// if user hit max signups
							if (resp.max_signups === true) {
								$rootScope.showTitle = 'Please log in to your account to add more domains.';
							} else if (typeof resp.errors != 'undefined') {
								$rootScope.showTitle = 'We currently only accept registrations from select countries.';
							}
						}
					} else {
						POP.Message.response($mainError,resp, false, false);
						$rootScope.showAlerts = true;
					}
				}

				// todo: handle our main suggestion

				// check if similar_domains is populated
				if (typeof resp.similar_domains != 'undefined' && resp.similar_domains.length > 0) {
					$rootScope.mainSuggestion = resp.similar_domains.shift();
					$rootScope.suggestions = resp.similar_domains;
				} else {
					$rootScope.mainSuggestion = null;
				}
			}

		}, function(error) {
			void 0;
		});
	}

    $scope.init();
});

App.controller('UserPassCtrl', function($scope,$location,$rootScope) {
	$scope.$watch('formUser.$valid', function(){
		$rootScope.validUserPass = $scope.formUser.$valid;
	});

        // focus on first input
        setTimeout(function() {
	        $('#formUser').find(':input').eq(0).focus();
	}, 50);

    /*
	$rootScope.$watch('formData.firstname', function(){
		if (typeof $rootScope.formData.firstname != 'undefined')
			$rootScope.formData.username = $rootScope.formData.firstname.replace(/ /g,"-");
	});
    */
});

App.controller('ContactCtrl', function($scope, $location, $rootScope, $routeParams, domainHelper){
	$rootScope.selectedStarterPage = null;
	$rootScope.showAlerts = false;

	// check if formData is not set
	if (!$rootScope.selectedDomain) {
		// check querystring first
		if ($routeParams.d) {
			validateDomain($routeParams.d);
		} else if (!$.cookie('pop_domain')) {
			// if cookie not set, redirect to first step
			$location.path('/register');
			$location.replace();
		} else {
			validateDomain($.cookie('pop_domain'));
		}
	}
	
        // focus on first input
        setTimeout(function() {	
	        $('#formInfo').find(':input').eq(0).focus();
	}, 50);

	$scope.$watch('formInfo.$valid', function() {
		$rootScope.validEmailInfo = $scope.formInfo.$valid;
	});
	
	/**
	 * Use our domain validation helper and handle response in callback.
	 */
	function validateDomain(value) {
		// let's validate the domain, just in case
		domainHelper.validateDomain(value, function(result) {
			// set formData.domain from querystring
			$rootScope.formData.domain = value;

			// handle validation response
			if (result == false) {
				// redirect to first step
				$location.path('/register');
				$location.replace();
				return false;
			}
		});
	}
});

App.controller('WhoisCtrl', function($scope, $rootScope, $location) {
	// reset if we dont have a domain
	if ($rootScope.selectedDomain == null) {
		$location.path('/register');
		$location.replace();
	}

        $rootScope.formData.whois_country = 'US';
        $rootScope.formData.whois_phone_countrycode = 'US';
        $rootScope.formData.whois_phone_countrycode_numeric = 1;
        $rootScope.formData.whois_phone = '+1 ';
        $rootScope.formData.privacy_enabled = 1;

    if (typeof $rootScope.formData.email != 'undefined') {
        if (typeof $rootScope.formData.whois_email == 'undefined' || !$rootScope.formData.whois_email.length) {
            $rootScope.formData.whois_email = $rootScope.formData.email;
        }
    }

    $rootScope.whoisPhoneErrors = false;
    $rootScope.validWhoisPhone = false;
    $rootScope.validWhois = false;

    // focus on first input
    setTimeout(function() {
        $('#formWhois').find('input[type="text"]').eq(0).focus();
	}, 50);

	$scope.$watch('formWhois.$valid', function() {
        void 0;
		$rootScope.validWhois = $scope.formWhois.$valid;
	});
});

App.controller('PaymentCtrl', function($scope, $rootScope, $location) {
	var coupon_code;

	// initially dont flag coupon as valid (or show)
	$scope.showPromo = false;
	$scope.couponCodeIsValid = false;
	$scope.validateCouponResponse = 'The coupon code you entered has been applied.';

	// reset if we dont have a domain
	if ($rootScope.selectedDomain == null) {
		$location.path('/register');
		$location.replace();
	}

	// also ensure WHOIS
	else if (!$rootScope.validWhois) {
		$location.path('/register/whois');
		$location.replace();
	}

	// initially set to not showing billing address
	$rootScope.validPayment = false;
	$scope.toggleBillingAddress = false;

	// check if a cookie coupon code is valid
	coupon_code = $.cookie('coupon_code');
	if (coupon_code && coupon_code.length) {
		$rootScope.validateCouponCode(true);
	}

        // focus on first input
        setTimeout(function() {
	        $('#formPayment').find(':input').eq(0).focus();
	}, 50);

	$scope.$watch('formPayment.$valid', function() {
		$rootScope.validPayment = $scope.formPayment.$valid;
	});
});

App.controller('EmailCtrl', function($scope, $rootScope, $location){
	// reset if we dont have a domain
	if ($rootScope.selectedDomain == null) {
		$location.path('/register');
		$location.replace();
	}

	$rootScope.emailErrors = false;
	$rootScope.validEmail = false;

        // focus on first input
        setTimeout(function() {
	        $('#formEmail').find(':input').eq(0).focus();
	}, 50);

	$scope.$watch('formEmail.$valid', function() {
		$rootScope.validEmail = $scope.formEmail.comm_email.$valid;
	});
});

App.controller('CellCtrl', function($scope, $rootScope, $location) {
	// reset if we dont have a domain
	if ($rootScope.selectedDomain == null) {
		$location.path('/register');
		$location.replace();
	}

	$rootScope.formData.cell_countrycode = 'US';
	$rootScope.formData.cell_countrycode_numeric = 1;
	$rootScope.formData.cell = '';

	$rootScope.cellErrors = false;
	$rootScope.validCell = false;

        // focus on first input
        setTimeout(function() {
	        $('#formCell').find(':input').eq(0).focus();
	}, 50);
});

App.controller('VerifyCtrl', function($routeParams, $rootScope, $scope, $location, validationHelper) {
	// check if formData is not set, if not you reached this route from a link
	if ($rootScope.selectedDomain == null) {
		$location.path('/register');
		$location.replace();
	}
	
	/*
	$scope.validatePin = function() {
		$('.step-6-verify').trigger('click');
		$rootScope.validatePin();
	}
	*/
});

App.controller('StarterPageCtrl', function($scope,$rootScope, $location) {
	//check for selectedDomain empty and reroute
	if(!$rootScope.selectedDomain) {
		$location.path('/register');
		$location.replace();
	}
});

App.controller('CompleteCtrl', function($routeParams, $rootScope, $scope, $location, validationHelper) {
	// reset payment success (we're done)
	$rootScope.paymentSuccess = false;

	// reset if we dont have a domain
	if ($rootScope.selectedDomain == null) {
		$location.path('/register');
		$location.replace();
	}

	$scope.$watch('formComplete.$valid', function(){
		$rootScope.completeValid = $scope.formComplete.$valid;
	});
});
